export const GOALS_ANATOMY_QUESTION =
  'What do you hope to gain from learning anatomy?'

export const GOALS_ANATOMY_OPTION_KEYS = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'sixth',
  'seventh',
] as const
